export default __webpack_public_path__ + "static/media/banner20230327.448f18d0.png";